module.exports = __webpack_public_path__ + "img/22.68a48e92.jpg";